import { Cancel, Check } from '@mui/icons-material'
import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import { ReactNode } from 'react'

type Props = {
  open: boolean
  message?: string | ReactNode
  onCancel?: () => void
  onConfirm?: () => void
  isDisableButton?: boolean
}

export default function ModalAreYouSure({ open, message, onCancel, onConfirm, isDisableButton }: Props) {
  return <Dialog
    id='modal-are-you-sure'
    open={open}
    onClose={onCancel}
  >
    <DialogContent>
      <Typography>
        Are you sure you want to {message}?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button
        id='modal-button-cancel'
        onClick={onCancel}
        color='error'
        startIcon={<Cancel />}
        disabled={isDisableButton}
      >
        Cancel
      </Button>
      <Button
        id='modal-button-confirm'
        onClick={onConfirm}
        startIcon={<Check />}
        disabled={isDisableButton}
      >
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
}
